











import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component({})
export default class ConfirmDialog extends Vue {
  @Prop({})
  private name!: string;
  @Prop({default: '340px'})
  private width!: string | number;
}
